class MegaskaCollectionImageHover {
  constructor() {
    this.cards = Array.from(document.querySelectorAll(".mk-product-card"));
    if (!this.cards.length) return;

    this.desktopMediaQuery = window.matchMedia("(min-width: 768px)");
    this.instances = [];

    this.init();
  }

  init() {
    this.cards.forEach((card) => {
      const track = card.querySelector("[data-product-media-track]");
      if (!track || !track.classList.contains("has-multiple")) return;

      const slides = Array.from(track.querySelectorAll(".mk-product-card__media-item"));
      if (slides.length < 2) return;

      let hoverTimeout = null;
      let stepTimeout = null;
      let currentIndex = 0;
      let isRunning = false;

      const slideDuration = 420;
      const pauseDuration = 1200;

      track.style.transition = `transform ${slideDuration}ms ease`;

      const goToSlide = (index) => {
        track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      };

      const runStepSequence = () => {
        if (!isRunning) return;

        if (currentIndex >= slides.length - 1) {
          isRunning = false;
          return;
        }

        currentIndex += 1;
        goToSlide(currentIndex);

        stepTimeout = window.setTimeout(() => {
          runStepSequence();
        }, slideDuration + pauseDuration);
      };

      const start = () => {
        if (!this.desktopMediaQuery.matches) return;
        if (hoverTimeout || stepTimeout || isRunning) return;

        hoverTimeout = window.setTimeout(() => {
          hoverTimeout = null;
          isRunning = true;
          runStepSequence();
        }, 120);
      };

      const stop = () => {
        if (hoverTimeout) {
          window.clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }

        if (stepTimeout) {
          window.clearTimeout(stepTimeout);
          stepTimeout = null;
        }

        isRunning = false;
        currentIndex = 0;

        track.style.transition = "transform 0.35s ease";
        track.style.transform = "translate3d(0, 0, 0)";

        window.setTimeout(() => {
          track.style.transition = `transform ${slideDuration}ms ease`;
        }, 350);
      };

      card.addEventListener("mouseenter", start);
      card.addEventListener("mouseleave", stop);

      this.instances.push({ stop });
    });

    this.desktopMediaQuery.addEventListener("change", (event) => {
      if (!event.matches) {
        this.instances.forEach((instance) => instance.stop());
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new MegaskaCollectionImageHover();
});
